import { Injectable } from '@angular/core';
import { AnagraficaDto, Comune, DatiParteA, DatiParteB } from '../model/model';
import { FormGroup } from '@angular/forms';
import { RandomDataService } from './random-data.service';

@Injectable({
  providedIn: 'root'
})
export class InserisciSchedaService {
  constructor(private randomService: RandomDataService) {
  }

  inserisciAnagrafica(anagrafica: any, parteA: any, parteB: any, id: number, modalita: boolean): AnagraficaDto {
    // Anagrafica
    let sesso = anagrafica?.get('sesso')?.value;
    let cognome = anagrafica?.get('cognome')?.value;
    let nome = anagrafica?.get('nome')?.value;
    let codiceFiscale = anagrafica?.get('codiceFiscale')?.value;
    let etaCompiuta = anagrafica?.get('etaCompiuta')?.value;
    let utenteString = sessionStorage.getItem('utente');
    let utente;
    if(utenteString != null){
      utente = JSON.parse(utenteString);
    }
    let codiceAslOperatoreInserimento = utente?.codiceAsl;
    codiceAslOperatoreInserimento = parseInt(utente.codiceAsl, 10);
    console.log("Codice asl: ", codiceAslOperatoreInserimento);
  
    let anagraficaDto: AnagraficaDto = {
      sesso: sesso,
      cognome: cognome,
      nome: nome,
      codiceFiscale: codiceFiscale,
      etaCompiuta: etaCompiuta,
      codiceAslOperatoreInserimento: codiceAslOperatoreInserimento,
      //da inserire solo quando la scheda è già creata e si va in modifica (decidere come gestirlo)
      // fkIdFlusso: this.randomService.getRandomInt(),
    };
  
    anagraficaDto.id = id;
  
    return anagraficaDto;
  }

  inserisciDatiParteA(parteA: any, idAnagrafica: number): DatiParteA {

    let fkLuogoDecesso = parteA?.get('fkLuogoDecesso')?.value;
    let luogoDecessoAltro = parteA?.get('luogoDecessoAltro')?.value;
    //comuneDecesso
    // let descrComune = parteA?.get('territorioDecesso')?.get('fkComuneDecesso')?.value;

    let fkComuneDecesso = parteA?.get('territorioDecesso')?.get('fkComuneDecesso')?.value;
    let codiceAslDecesso = parteA?.get('territorioDecesso')?.get('codiceAslDecesso')?.value;
    let riscontroDiagnostico = parteA?.get('riscontroDiagnostico')?.value;
    let causaInizialeDecesso = 'prov';
    let causaInizialeDecesso2 = 'prov';
    let fkStatoGravidanza = parteA?.get('fkStatoGravidanza')?.value;
    let causaDiMorte1 = parteA?.get('causaMortePatologia')?.get('causaDiMorte1')?.value;
    let causaDiMorte1Anni = parteA?.get('causaMortePatologia')?.get('causaDiMorte1Anni')?.value;
    let causaDiMorte1Mesi = parteA?.get('causaMortePatologia')?.get('causaDiMorte1Mesi')?.value;
    let causaDiMorte1Giorni = parteA?.get('causaMortePatologia')?.get('causaDiMorte1Giorni')?.value;
    let causaDiMorte2 = parteA?.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2')?.value;
    let causaDiMorte2Anni = parteA?.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Anni')?.value;
    let causaDiMorte2Mesi = parteA?.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Mesi')?.value;
    let causaDiMorte2Giorni = parteA?.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Giorni')?.value;
    let causaDiMorte3 = parteA?.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3')?.value;
    let causaDiMorte3Anni = parteA?.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Anni')?.value;
    let causaDiMorte3Mesi = parteA?.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Mesi')?.value;
    let causaDiMorte3Giorni = parteA?.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Giorni')?.value;
    let causaDiMorte4 = parteA?.get('causaMorteCondizioni')?.get('condizione3')?.get('condizione')?.value;
    let causaDiMorte4Anni = parteA?.get('causaMorteCondizioni')?.get('condizione3')?.get('anni')?.value;
    let causaDiMorte4Mesi = parteA?.get('causaMorteCondizioni')?.get('condizione3')?.get('mesi')?.value;
    let causaDiMorte4Giorni = parteA?.get('causaMorteCondizioni')?.get('condizione3')?.get('giorni')?.value;
    let statiMorbosi1 = parteA?.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1')?.value;
    let statiMorbosi1Anni = parteA?.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1Anni')?.value;
    let statiMorbosi1Mesi = parteA?.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1Mesi')?.value;
    let statiMorbosi1Giorni = parteA?.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1Giorni')?.value;
    let statiMorbosi2 = parteA?.get('altriStatiMorbosi')?.get('stato2')?.get('stato')?.value;
    let statiMorbosi2Anni = parteA?.get('altriStatiMorbosi')?.get('stato2')?.get('anni')?.value;
    let statiMorbosi2Mesi = parteA?.get('altriStatiMorbosi')?.get('stato2')?.get('mesi')?.value;
    let statiMorbosi2Giorni = parteA?.get('altriStatiMorbosi')?.get('stato2')?.get('giorni')?.value;
    let statiMorbosi3 = parteA?.get('altriStatiMorbosi')?.get('stato3')?.get('stato')?.value;
    let statiMorbosi3Anni = parteA?.get('altriStatiMorbosi')?.get('stato3')?.get('anni')?.value;
    let statiMorbosi3Mesi = parteA?.get('altriStatiMorbosi')?.get('stato3')?.get('mesi')?.value;
    let statiMorbosi3Giorni = parteA?.get('altriStatiMorbosi')?.get('stato3')?.get('giorni')?.value;
    let eventoTraumatismo = parteA?.get('eventoTraumatismo')?.value;
    let eventoOrigineTraumatismo = parteA?.get('eventoOrigineTraumatismo')?.value;
    let fkModalitaTraumatismo = parteA?.get('fkModalitaTraumatismo')?.value;
    let traumatismoSulLavoro = parteA?.get('traumatismoSulLavoro')?.value;
    let incidenteTrasportoMezzo = parteA?.get('incidenteTrasporti')?.get('incidenteTrasportoMezzo')?.value;
    let fkIncidenteTrasportoRuolo = parteA?.get('incidenteTrasporti')?.get('fkIncidenteTrasportoRuolo')?.value;
    let incidenteTrasportoTipo = parteA?.get('incidenteTrasporti')?.get('incidenteTrasportoTipo')?.value;
    let incidenteTrasportoScontro = parteA?.get('incidenteTrasporti')?.get('incidenteTrasportoScontro')?.value;
    let orarioEventoHh = parteA?.get('dataEvento')?.get('orarioEventoHh')?.value;
    let orarioEventoMm = parteA?.get('dataEvento')?.get('orarioEventoMm')?.value;

    //devo convertire data8selected in Date poichè viene restituita come un oggetto
    const data8Object = parteA?.get('dataEvento')?.get('data8selected')?.value;
    let giornoEvento = '';
    let meseEvento = '';
    let annoEvento = '';
    //FIXME: Qui data8Object può esssere null
    if (data8Object != undefined) {
      const data8Date = new Date(data8Object.year, data8Object.month - 1, data8Object.day);
      giornoEvento = data8Date.getDate().toString();
      const meseEventoNumerico = data8Date.getMonth() + 1;
      meseEvento = meseEventoNumerico.toString();
      annoEvento = data8Date.getFullYear().toString();
    }
    else {
      const data8DateToday = new Date();
      giornoEvento = data8DateToday.getDate().toString();
      const meseEventoNumerico = data8DateToday.getMonth() + 1;
      meseEvento = meseEventoNumerico.toString();
      annoEvento = data8DateToday.getFullYear().toString();
    }
    //

    let fkLuogoEvento = parteA?.get('fkLuogoEvento')?.value;
    let luogoEventoAltro = parteA?.get('altroLuogoEvento')?.value;

    let dataCompilazioneValue = parteA?.get('dichiarazioni')?.get('dataCompilazione')?.value;
    const dataCompilazione = new Date(dataCompilazioneValue.year, dataCompilazioneValue.month - 1, dataCompilazioneValue.day, 12, 30);

    let fkTipoMedico = parteA?.get('dichiarazioni')?.get('fkTipoMedico')?.value;
    let telefonoRiferimento = parteA?.get('dichiarazioni')?.get('telefonoRiferimento')?.value;
    let nomeCognomeMedico = parteA?.get('dichiarazioni')?.get('nomeCognomeMedico')?.value;
    let validazione = false;
    let causaDiMorte1Cod = parteA?.get('causaMortePatologia')?.get('causaDiMorte1Cod')?.value;
    let causaDiMorte2Cod = parteA?.get('causaMorteCondizioni')?.get('condizione1')?.get('causaDiMorte2Cod')?.value;
    let causaDiMorte3Cod = parteA?.get('causaMorteCondizioni')?.get('condizione2')?.get('causaDiMorte3Cod')?.value;
    let causaDiMorte4Cod = parteA?.get('causaMorteCondizioni')?.get('condizione3')?.get('causaDiMorte4Cod')?.value;

    console.log("causaDiMorte1Cod: ", causaDiMorte1Cod);
    console.log("causaDiMorte2Cod: ", causaDiMorte2Cod);
    console.log("causaDiMorte3Cod: ", causaDiMorte3Cod);
    console.log("causaDiMorte4Cod: ", causaDiMorte4Cod);

    let statiMorbosi1Cod = parteA?.get('altriStatiMorbosi')?.get('stato1')?.get('statiMorbosi1Cod')?.value;
    let statiMorbosi2Cod = parteA?.get('altriStatiMorbosi')?.get('stato2')?.get('statiMorbosi2Cod')?.value;
    let statiMorbosi3Cod = parteA?.get('altriStatiMorbosi')?.get('stato3')?.get('statiMorbosi3Cod')?.value;

    console.log("statiMorbosi1Cod: ", statiMorbosi1Cod);
    console.log("statiMorbosi2Cod: ", statiMorbosi2Cod);
    console.log("statiMorbosi3Cod: ", statiMorbosi3Cod);

    return {
      id: idAnagrafica,
      fkLuogoDecesso: fkLuogoDecesso,
      luogoDecessoAltro: luogoDecessoAltro,
      fkComuneDecesso: fkComuneDecesso,
      codiceAslDecesso: codiceAslDecesso,
      riscontroDiagnostico: riscontroDiagnostico,
      causaInizialeDecesso: causaInizialeDecesso,
      causaInizialeDecesso2: causaInizialeDecesso2,
      fkStatoGravidanza: fkStatoGravidanza,
      causaDiMorte1Cod: causaDiMorte1Cod,
      causaDiMorte2Cod: causaDiMorte2Cod,
      causaDiMorte3Cod: causaDiMorte3Cod,
      causaDiMorte4Cod: causaDiMorte4Cod,
      causaDiMorte1: causaDiMorte1,
      causaDiMorte1Anni: causaDiMorte1Anni,
      causaDiMorte1Mesi: causaDiMorte1Mesi,
      causaDiMorte1Giorni: causaDiMorte1Giorni,
      causaDiMorte2: causaDiMorte2,
      causaDiMorte2Anni: causaDiMorte2Anni,
      causaDiMorte2Mesi: causaDiMorte2Mesi,
      causaDiMorte2Giorni: causaDiMorte2Giorni,
      causaDiMorte3: causaDiMorte3,
      causaDiMorte3Anni: causaDiMorte3Anni,
      causaDiMorte3Mesi: causaDiMorte3Mesi,
      causaDiMorte3Giorni: causaDiMorte3Giorni,
      causaDiMorte4: causaDiMorte4,
      causaDiMorte4Anni: causaDiMorte4Anni,
      causaDiMorte4Mesi: causaDiMorte4Mesi,
      causaDiMorte4Giorni: causaDiMorte4Giorni,
      statiMorbosi1Cod: statiMorbosi1Cod,
      statiMorbosi2Cod: statiMorbosi2Cod,
      statiMorbosi3Cod: statiMorbosi3Cod,
      statiMorbosi1: statiMorbosi1,
      statiMorbosi1Anni: statiMorbosi1Anni,
      statiMorbosi1Mesi: statiMorbosi1Mesi,
      statiMorbosi1Giorni: statiMorbosi1Giorni,
      statiMorbosi2: statiMorbosi2,
      statiMorbosi2Anni: statiMorbosi2Anni,
      statiMorbosi2Mesi: statiMorbosi2Mesi,
      statiMorbosi2Giorni: statiMorbosi2Giorni,
      statiMorbosi3: statiMorbosi3,
      statiMorbosi3Anni: statiMorbosi3Anni,
      statiMorbosi3Mesi: statiMorbosi3Mesi,
      statiMorbosi3Giorni: statiMorbosi3Giorni,
      eventoTraumatismo: eventoTraumatismo,
      eventoOrigineTraumatismo: eventoOrigineTraumatismo,
      fkModalitaTraumatismo: fkModalitaTraumatismo,
      traumatismoSulLavoro: traumatismoSulLavoro,
      incidenteTrasportoMezzo: incidenteTrasportoMezzo,
      fkIncidenteTrasportoRuolo: fkIncidenteTrasportoRuolo,
      incidenteTrasportoTipo: incidenteTrasportoTipo,
      incidenteTrasportoScontro: incidenteTrasportoScontro,
      orarioEventoHh: orarioEventoHh,
      orarioEventoMm: orarioEventoMm,
      giornoEvento: giornoEvento,
      meseEvento: meseEvento,
      annoEvento: annoEvento,
      fkLuogoEvento: fkLuogoEvento,
      luogoEventoAltro: luogoEventoAltro,
      dataCompilazione: dataCompilazione,
      fkTipoMedico: fkTipoMedico,
      telefonoRiferimento: telefonoRiferimento,
      nomeCognomeMedico: nomeCognomeMedico,
      validazione: validazione,
      // validazioneData: new Date(),
      // riaperturaData: new Date(),
      createdBy: this.randomService.getRandomString(),
      modifiedBy: this.randomService.getRandomString(),
      createdOn: new Date(),
      modifiedOn: new Date()
    };
  }

  inserisciDatiParteB(parteB: any, idAnagrafica: number, anagraficaForm: any): DatiParteB {

    let attoMorteNumero = parteB?.get('attoMorteNumero')?.value;
    let parte1 = parteB?.get('parte1')?.value;
    let serie1 = parteB?.get('serie1')?.value;
    let circoscrizione = parteB?.get('circoscrizione')?.value;
    let fkComune = parteB?.get('denominazione')?.get('fkComune')?.value;
    let dataMorteHh = parteB?.get('dataMorte')?.get('dataMorteHh')?.value;
    let dataMorteMm = parteB?.get('dataMorte')?.get('dataMorteMm')?.value;
    //converto da oggetto a Date
    let giornoDataMorte = parteB?.get('dataMorte')?.get('data')?.value;
    let giornoMorte = '';
    let meseMorte = '';
    let annoMorte = '';
    if (giornoDataMorte != undefined) {
      const dataMorteDate = new Date(giornoDataMorte?.year, giornoDataMorte?.month - 1, giornoDataMorte?.day);
      giornoMorte = dataMorteDate.getDate().toString();
      const meseMorteNumerico = dataMorteDate.getMonth() + 1;
      meseMorte = meseMorteNumerico.toString();
      annoMorte = dataMorteDate.getFullYear().toString();
    }
    else{
      const dataMorteDateToday = new Date();
      giornoMorte = dataMorteDateToday.getDate().toString();
      const meseMorteNumerico = dataMorteDateToday.getMonth() + 1;
      meseMorte = meseMorteNumerico.toString();
      annoMorte = dataMorteDateToday.getFullYear().toString();
    }
    //
    //converto da oggetto a Date
    let dataNascita = parteB?.get('dataNascita')?.value;
    let giornoNascita = '';
    let meseNascita = '';
    let annoNascita = '';
    if(dataNascita != undefined){
      const dataNascitaDate = new Date(dataNascita?.year, dataNascita?.month - 1, dataNascita?.day);
      giornoNascita = dataNascitaDate.getDate().toString();
      const meseNascitaNumerico = dataNascitaDate.getMonth() + 1;
      meseNascita = meseNascitaNumerico.toString();
      annoNascita = dataNascitaDate.getFullYear().toString();
    }
    else{
      const dataNascitaDateToday = new Date();
      giornoNascita = dataNascitaDateToday.getDate().toString();
      const meseNascitaNumerico = dataNascitaDateToday.getMonth() + 1;
      meseNascita = meseNascitaNumerico.toString();
      annoNascita = dataNascitaDateToday.getFullYear().toString();
    }
    //
    let fkLocalitaNascita = parteB?.get('fkLocalitaNascita')?.value;
    let fkLocalitaComuneNascita = parteB?.get('altroComuneNascita')?.get('fkLocalitaComuneNascita')?.value;
    let fkLocalitaStatoEsteroNascita = parteB?.get('fkLocalitaStatoEsteroNascita')?.value;
    let etaCompiuta = parteB?.get('etaCompiuta')?.value;
    let fkStatoCivile = parteB?.get('fkStatoCivile')?.value;
    let annoNasciutaConiuge = parteB?.get('casiStatoCivile')?.get('annoNascitaConiuge')?.value;
    let annoMatrimonioUnione = parteB?.get('casiStatoCivile')?.get('annoMatrimonioUnione')?.value;
    let fkLocalitaResidenza = parteB?.get('fkLocalitaResidenza')?.value;
    let fkComuneResidenza = parteB?.get('altroComuneResidenza')?.get('fkComuneResidenza')?.value;
    let fkStatoResidenza = parteB?.get('fkStatoResidenza')?.value;
    let fkGradoIstruzione = parteB?.get('fkGradoIstruzione')?.value;
    let professione = parteB?.get('professione')?.value;
    let fkCondizioneProfessionale = parteB?.get('fkCondizioneProfessionale')?.value;
    let fkPosizioneProfessione = parteB?.get('fkPosizioneProfessione')?.value;
    let fkRamoAttivitaEconomica = parteB?.get('fkRamoAttivitaEconomica')?.value;
    let fkCittadinanza = parteB?.get('fkCittadinanza')?.value;
    let fkCittadinanzaStatoStraniera = parteB?.get('fkCittadinanzaStatoStraniera')?.value;
    let recapito = parteB?.get('firmaRecapitiUfficiale')?.get('recapito')?.value;
    let telefono = parteB?.get('firmaRecapitiUfficiale')?.get('telefono')?.value;
    let email = parteB?.get('firmaRecapitiUfficiale')?.get('email')?.value;
    let validazione = false;

    return {
      id: idAnagrafica,
      sesso: anagraficaForm.get('sesso')?.value,
      attoMorteNumero: attoMorteNumero,
      parte1: parte1,
      parte2: parte1,
      serie1: serie1,
      serie2: serie1,
      circoscrizione: circoscrizione,
      fkComune: fkComune,
      dataMorteHh: dataMorteHh,
      dataMorteMm: dataMorteMm,
      giornoDataMorte: giornoMorte,
      meseDataMorte: meseMorte,
      annoDataMorte: annoMorte,
      giornoNascita: giornoNascita,
      meseNascita: meseNascita,
      annoNascita: annoNascita,
      fkLocalitaNascita: fkLocalitaNascita,
      fkLocalitaComuneNascita: fkLocalitaComuneNascita,
      fkLocalitaStatoEsteroNascita: fkLocalitaStatoEsteroNascita,
      etaCompiuta: etaCompiuta,
      fkStatoCivile: fkStatoCivile,
      annoNascitaConiuge: annoNasciutaConiuge,
      annoMatrimonioUnione: annoMatrimonioUnione,
      fkLocalitaResidenza: fkLocalitaResidenza,
      fkComuneResidenza: fkComuneResidenza,
      fkStatoResidenza: fkStatoResidenza,
      fkGradoIstruzione: fkGradoIstruzione,
      professione: professione,
      fkCondizioneProfessionale: fkCondizioneProfessionale,
      fkPosizioneProfessione: fkPosizioneProfessione,
      fkRamoAttivitaEconomica: fkRamoAttivitaEconomica,
      fkCittadinanza: fkCittadinanza,
      fkCittadinanzaStatoStraniera: fkCittadinanzaStatoStraniera,
      recapito: recapito,
      telefono: telefono,
      email: email,
      validazione: validazione,
      // validazioneData: new Date(),
      // riaperturaData: new Date(),
      createdBy: this.randomService.getRandomString(),
      modifiedBy: this.randomService.getRandomString(),
      createdOn: new Date(),
      modifiedOn: new Date()
    };
  }
}
